import { MetaTagsAll } from '../../../interfaces/meta.interface';

export const MetaTagsHomepage: MetaTagsAll = {
  title: 'Talenteer: AI-Powered Platform for Efficient Talent Allocation',
  description:
    'Talenteer is a platform that optimizes talent allocation, enhances internal mobility, and reduces hiring costs through AI-driven talent matching and data insights.',
  contentLanguage: 'en',
  robots: '',
  canonicalUrl: `${process.env.SITE_URL}`,
  ogDescription: '',
  ogDeterminer: '',
  ogImage: '',
  ogSiteName: '',
  ogTitle: '',
  ogType: '',
  ogUrl: '',
};
